import React, {Component} from "react";
import withStyles from '@material-ui/core/styles/withStyles';


//import { withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper/index";
import {Typography} from "@material-ui/core";
import Table from "@material-ui/core/Table/index";
import TableBody from "@material-ui/core/TableBody/index";
import TableCell from "@material-ui/core/TableCell/index";
import TableHead from "@material-ui/core/TableHead/index";
import TableRow from "@material-ui/core/TableRow/index";
import moment from 'moment/moment';

import 'typeface-montserrat';
import firebase from 'firebase';

const CustomTableCell = withStyles(theme => ({
    head: {
        //backgroundColor: theme.palette.background.paper,
        color: theme.palette.common.white,
        borderColor: theme.palette.background.paper,
        fontSize: 18

    },
    body: {
        fontSize: 24,
        color: theme.palette.common.white,
        borderColor: theme.palette.background.paper


    }
}))(TableCell);

var alignName = {
    margin: 'auto',
    padding: '10px',
    float:'right',
    fontSize: 24
}

const styles = theme => ({

    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
        marginTop: theme.spacing.unit * 3,
        overflowX: "auto"
    },
    table: {
        minWidth: 350,
        minHeight: 325

    },
    row: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.background.paper
        },
    }
});

let _data = {
    '0': {
        key: "",
        value: 0,
        url: ""
    },
    '1': {
        key: "",
        value: 0,
        url: ""
    },
    '2': {
        key: "",
        value: 0,
        url: ""
    },
    '3': {
        key: "",
        value: 0,
        url: ""
    },
    '4': {
        key: "",
        value: 0,
        url: ""
    }
};

const DevStore = {
    listeners: [],

    get data() {
        return _data;
    },
    set data(val) {
        //  console.log("authorization : Basic "+val);
        fetch('https://us-central1-lumdash.cloudfunctions.net/bestDeveloper',{
            //fetch('http://localhost:5000/lumdash/us-central1/bestDeveloper',{
            method: 'GET',
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Basic '+ val
            }
        })
            .then(response => {
                //console.log('Response : '+ response.status + ' ' + response.statusText);
                if(response.ok) {
                    return response.json()
                }
                else{
                    return _data;
                }
            })
            .then(data => {
                _data = data;
            })
            .then(()=>{
                this.notify();
            })
            .catch(e =>{
                console.log(e);
            });
    },
    listen(handler) {
        this.listeners.push(handler);
    },
    remove(handler) {
        this.listeners = this.listeners.filter(x => x !== handler);
    },
    notify() {
        this.listeners.forEach(f => f());
    }
};

class bestDeveloper extends Component {


    constructor(props){
        super(props);
        this.state = {
            data: DevStore.data
        }
        //First Fetch
        //DevStore.data = this.props.anUser;
        firebase.auth().currentUser.getIdToken(true).then(function(idToken){
            //console.log(idToken);

            DevStore.data = idToken;
        });
    }

    update = () => {
        this.setState({data: DevStore.data});
    }

    componentDidMount(){

        setInterval(function(){
            //console.log("best dev token : " + self.props.anUser)
            firebase.auth().currentUser.getIdToken(true).then(function(idToken){
                //console.log(idToken);
                DevStore.data = idToken;
            });

            //DevStore.data = self.props.anUser;
        },1000*60);

        DevStore.listen(this.update);

    }


    render() {
        const { classes } = this.props;

        return (

            <Paper className="table-issues" >
                <Typography className="table-issues" variant="h5" gutterBottom style={{color: 'white'}}>Issue Killers : {moment().format('MMMM')}</Typography>
                <Table className={classes.table} >
                    <TableHead>
                        <TableRow>
                            <CustomTableCell>Killer</CustomTableCell>
                            <CustomTableCell>RIP Issues</CustomTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow  key={1} >

                            <CustomTableCell component="th">
                                <div>
                                    <div style={{float: 'left'}}>
                                        <img
                                            src= {this.state.data['0'].url}
                                            alt=" {no pics :(    } "
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                    <div style={alignName}>
                                        {this.state.data['0'].key}
                                    </div>
                                </div>
                            </CustomTableCell>

                            <CustomTableCell align="right">{this.state.data['0'].value}</CustomTableCell>
                        </TableRow>
                        <TableRow  key={2}>
                            <CustomTableCell component="th">
                                <div>
                                    <div style={{float: 'left'}}>
                                        <img
                                            src= {this.state.data['1'].url}
                                            alt=" {no pics :(    } "
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                    <div style={alignName}>
                                        {this.state.data['1'].key}
                                    </div>
                                </div>
                            </CustomTableCell>
                            <CustomTableCell align="right">{this.state.data['1'].value}</CustomTableCell>
                        </TableRow>
                        <TableRow  key={3} >
                            <CustomTableCell component="th">
                                <div>
                                    <div style={{float: 'left'}}>
                                        <img
                                            src= {this.state.data['2'].url}
                                            alt=" {no pics :(    } "
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                    <div style={alignName}>
                                        {this.state.data['2'].key}
                                    </div>
                                </div>
                            </CustomTableCell>
                            <CustomTableCell align="right">{this.state.data['2'].value}</CustomTableCell>
                        </TableRow>
                        <TableRow  key={4} >
                            <CustomTableCell component="th">
                                <div>
                                    <div style={{float: 'left'}}>
                                        <img
                                            src= {this.state.data['3'].url}
                                            alt=" {no pics :(    } "
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                    <div style={alignName}>
                                        {this.state.data['3'].key}
                                    </div>
                                </div>
                            </CustomTableCell>
                            <CustomTableCell align="right">{this.state.data['4'].value}</CustomTableCell>
                        </TableRow>
                        <TableRow  key={5} >
                            <CustomTableCell component="th">
                                <div>
                                    <div style={{float: 'left'}}>
                                        <img
                                            src= {this.state.data['4'].url}
                                            alt=" {no pics :(    } "
                                            width="48"
                                            height="48"
                                        />
                                    </div>
                                    <div style={alignName}>
                                        {this.state.data['4'].key}
                                    </div>
                                </div>
                            </CustomTableCell>
                            <CustomTableCell align="right">{this.state.data['4'].value}</CustomTableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>

        );
    }
}

export default  withStyles(styles)(bestDeveloper);



// WEBPACK FOOTER //
// ./src/components/Tables/bestDev.js